module.exports = __webpack_public_path__ + "img/1477711900.713afbc9.jpg";